     <template>
        <div class="fwxm_main center">
           
           <ul>
              <li v-for="item in fwxm_list">
                   <router-link :to="{name:'mecase',params:{id:item.id}}" tag="a">
                     <div>
                           <img :src="item.img"/>
                        </div>
                        <div class="t_top">
                           <p>
                              {{item.name}}
                           </p>
                        </div> 
       
                        <div class="t_bottom f14">
                            <p>
                               {{item.scene}}
                            </p>
       
                             <p>
                                  {{item.nature}}
                             </p>
                        </div> 
       
                   </router-link>
              </li>
           </ul>  



        </div>
      </template>



      <script>
         export default({

            data(){
               return({
                  current: 0,//导航选中
                  fwxm_list:[
                           {
                           id: 1,
                           img: require("@/assets/images/website.jpg"),
                           name: "网站建设",
                           scene: "针对性网站优化",
                           nature: "网站建设",
                           intro: [
                              "域名，空间，国外空间",
                              "高端品牌网站建设、网页设计",
                              "网站优化推广",
                              "一站式网站运营"
                           ]
                           },
                           {
                           id: 2,
                           img: require("@/assets/images/weixinlogo.jpg"),
                           name: "微信应用",
                           scene: "微信应用开发",
                           nature: "网络运营",
                           intro: [
                              "域名，空间，国外空间",
                              "高端品牌网站建设、网页设计",
                              "网站优化推广",
                              "一站式网站运营"
                           ]
                           },
                           {
                           id: 3,
                           img: require("@/assets/images/APP.jpg"),
                           name: "软件开发",
                           scene: "IOS、Android",
                           nature: "研究开发",
                           intro: [
                              "域名，空间，国外空间",
                              "高端品牌网站建设、网页设计",
                              "网站优化推广",
                              "一站式网站运营"
                           ]
                           },
                           {
                           id: 4,
                           img: require("@/assets/images/brand.jpg"),
                           name: "品牌设计",
                           scene: "根据客户所在行业",
                           nature: "设计品牌",
                           intro: [
                              "域名，空间，国外空间",
                              "高端品牌网站建设、网页设计",
                              "网站优化推广",
                              "一站式网站运营"
                           ]
                           },
                  ]
               })
            }

         })
      
      </script>


<style lang="less" scoped >

  .fwxm_main {
     /* background:url(../../assets/images/successfulcase.jpg); */

      ul{
         /* border: 1px solid #e50012; */
         overflow: hidden;
         border-radius:5px
      }
      li{
         list-style: none;
         width: 48%;
         float: left;
         background: #fff;
         margin: 1%;
         /* border: 1px solid #e50012; */
         box-sizing: border-box;

         img{
            margin: 20px auto ;
         }

         .t_top{
            margin-bottom: 10px;
            font-size: 14px;
            color: #e50012;
         }

         .t_bottom{
               color: #666;
               margin-bottom: 20px;
               line-height: 20px;
         }
      }

   }

</style>


// WEBPACK FOOTER //
// src/components/move/fwxm.vue